import React from "react";
import MuiTitle from "@material-ui/core/DialogTitle";
import CloseButton from "../../CloseButton";
import withStyles from "../../../styles/withStyles";

function Title({ classes, children, onClose, ...props }) {
  return (
    <MuiTitle
      disableTypography
      classes={{
        root: classes.root
      }}
      {...props}
    >
      <div className={classes.title}>{children}</div>
      {onClose && (
        // this extra div allows the close button to be centered with the text
        // but remain at the top of the container if the title flows over to
        // the next line
        <div className={classes.closeButton}>
          <CloseButton onClick={onClose} />
        </div>
      )}
    </MuiTitle>
  );
}

let styles = theme => ({
  root: {
    display: "flex",
    alignItems: "flex-start",
    borderBottom: "2px solid black",
    marginBottom: "12px",
    padding: "0",
    fontSize: "22px"
  },
  title: {
    flex: "1 1 auto",
    fontFamily: theme.typography.fontFamilyHeader
  },
  closeButton: {
    position: "relative",
    bottom: "5px"
  }
});

export default withStyles(styles)(Title);
